export default "__VITE_ASSET__DDJkg1b9__"